import { render, staticRenderFns } from "./modal-feedback.vue?vue&type=template&id=783210fb&scoped=true&"
import script from "./modal-feedback.vue?vue&type=script&lang=js&"
export * from "./modal-feedback.vue?vue&type=script&lang=js&"
import style0 from "./modal-feedback.vue?vue&type=style&index=0&id=783210fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783210fb",
  null
  
)

export default component.exports